export enum TodoTags {
  ACCOMMODATION = "Boende",
  APPLICATION = "Intresseanmälan",
  AWAITING_CONFIRMATION = "Inväntar bekräftelse (boende)",
  AWAITING_SQM = "Inväntar kvm från boende",
  AWAITING_FEEDBACK = "Inväntar återkoppling (konsult)",
  BIRTHDAY = "Födelsedag",
  CONSULTANT = "Konsult",
  CONTRACT = "Avtal",
  CONTRACT_PHASE = "Avtalsfas",
  CPR = "HLR",
  CRIMINAL_RECORD = "Belastningsregister",
  CUSTOMER = "Kund",
  HEALTH_FORM = "Hälsodeklaration",
  HOSP = "HOSP",
  IVO = "IVO",
  NO_ANSWER = "Ej svar",
  NORWAY_HPR = "Norge HPR (intresseanmälan)",
  NOT_CONTACTED = "Uppföljning",
  PB_OTHER = "PB/övrigt",
  REFERENCE = "Referens",
  SAK = "SAK",
  TRAVEL = "Resa",
  SUBSTRATE_CERTIFICATE = "Underlagsattest",
  ASSIGNMENT_EVALUATION = "Uppdragsutvärdering",
  "Siths-kort" = "Siths-kort"
}
